import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor() {}

  public convertBase64ToFile(data, filename, mimetype) {
    const full_data = 'data:' + mimetype + ';base64,' + data;
    return fetch(full_data).then(res => {
      return res.arrayBuffer().then(buf => {
        return new File([buf], filename, { type: mimetype });
      });
    });
  }
  public redirectRefreshed(url: string) {
    window.location.href = url;
  }
}
